import React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';

// export interface OptionType {
//     label: string;
//     value: string | number;
// }

// export interface MultiSelectWithReFetcherProps {
//     isTouched: boolean;
//     isError: boolean;
//     isLoading: boolean;
//     isDisabled?: boolean;
//     isDisablePortal?: boolean;
//     name: string;
//     label: string;
//     options: OptionType[];
//     selectedValues: OptionType[];
//     onChange: (name: string, values: OptionType[]) => void;
//     reFetch?: () => void;
//     errorMessage?: string;
// }

const MultiSelectWithReFetcher = ({isTouched, isError, isLoading, isDisabled = false, isDisablePortal = true, name, label, options, selectedValues, onChange, reFetch, errorMessage}) => {
    return (
        <FormControl fullWidth error={isTouched && isError}>
            <Autocomplete
                disablePortal={isDisablePortal}
                options={options}
                multiple
                value={selectedValues ?? []}
                isOptionEqualToValue={(option, value) => option?.value === value?.value}
                onChange={(event, value) => {
                    onChange(name, value ?? []);
                }}
                onOpen={reFetch}
                loading={isLoading}
                disabled={isDisabled}
                renderInput={(params) => (
                    <TextField
                        label={label ? label : ''}
                        {...params}
                        InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                                <React.Fragment>
                                    {isLoading ? <CircularProgress color="inherit" size={20} /> : null}
                                    {params.InputProps.endAdornment}
                                </React.Fragment>
                            )
                        }}
                    />
                )}
            />
            {isTouched && isError && (
                <FormHelperText error id="standard-weight-helper-text-password-login">
                    {errorMessage}
                </FormHelperText>
            )}
        </FormControl>
    );
};

export default MultiSelectWithReFetcher;
